document.addEventListener("DOMContentLoaded", () => {
  // Dawn uses <deferred-media> for video embeds/hosted video
  const deferred = document.querySelector("deferred-media");
  if (deferred && typeof deferred.loadContent === "function") {
    deferred.loadContent(); // force it to load now
  }

  // Try to play any autoplay video once it exists
  const tryPlay = () => {
    const v = document.querySelector("video");
    if (!v) return;

    v.muted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    v.setAttribute("playsinline", "");

    v.play().catch(() => {});
  };

  // try immediately and again shortly after
  tryPlay();
  setTimeout(tryPlay, 500);
  setTimeout(tryPlay, 1500);
});
